import { createApp } from "vue";
import App from "./App.vue";

export function createPickACardApp() {
	const app = createApp(App);

	app.mount("#pick-a-card-app");
}
